import { makeStyles } from 'tss-react/mui';

const useStylesStatusIconBlock: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  statusIconBlock: {
    width: 24,
    height: 24,
    minWidth: 24,
    '&:empty': {
      display: 'none',
    },
  },
  statusIconBlockLeftOffset: {
    marginLeft: 32,
  },
  statusIconBlockRightOffset: {
    marginRight: 10,
  },
}));

export default useStylesStatusIconBlock;
